import React from 'react';
import {Avatar} from 'antd';
import {useLoggedUser} from "../../context/LoggedUserContext";
import {Link} from "react-router-dom";

const UserInfo = () => {
    const {user} = useLoggedUser();

    return (
        <>
            {user &&
                <div className="dropdown order-lg-1 ms-auto">
                    <button type="button" id="userDropdown" className="user-avatar nav-link dropdown-toggle d-flex align-items-center p-0" data-bs-toggle="dropdown" aria-expanded="false">
                        <Avatar src={user.avatar} shape="circle" size={40} />
                    </button>
                    <ul className="dropdown-menu dropdown-menu-right dropdown-menu-user bg-secondary"
                        aria-labelledby="userDropdown"
                    >
                        <li>
                            <Link className="dropdown-item" to={`/profile/${user.name}`}>
                                <i className="fa fa-fw fa-user"></i>
                                MY PROFILE
                            </Link>
                        </li>
                        {user.isSteward && !user.isAdmin && (
                            <li>
                                <a className="dropdown-item" href="/admin/report">
                                    <i className="fa fa-fw fa-flag"></i>
                                    STEWARD PANEL
                                </a>
                            </li>
                        )}
                        {user.isEditor && !user.isAdmin && (
                            <li>
                                <a className="dropdown-item" href="/admin/post">
                                    <i className="fa fa-fw fa-edit"></i>
                                    EDITOR PANEL
                                </a>
                            </li>
                        )}
                        {user.isPR && !user.isAdmin && (
                            <li>
                                <a className="dropdown-item" href="/admin">
                                    <i className="fa fa-fw fa-edit"></i>
                                    EDITOR PANEL
                                </a>
                            </li>
                        )}
                        {user.isAdmin && (
                            <li>
                                <a className="dropdown-item" href="/admin">
                                    <i className="fa fa-fw fa-cog"></i>
                                    ADMIN PANEL
                                </a>
                            </li>
                        )}
                        <li>
                            <a className="dropdown-item" href="/logout">
                                <i className="fa fa-fw fa-sign-out-alt"></i>
                                LOGOUT
                            </a>
                        </li>
                    </ul>
                </div>
            }
            {!user &&
                <div className="login-with-steam order-lg-1">
                    <a href={'/auth/steam'} className="nav-link font-style-semibold">
                        <i className="fa fa-steam fa-xl me-1"></i>
                        <span>SIGN IN</span>
                    </a>
                </div>
            }
        </>
    );
}

export default UserInfo;
